import { API_BASE_URL } from "../utils";
import "./MyInvitesCard.css";
import { IoRestaurantSharp } from "react-icons/io5";
import { BiDrink } from "react-icons/bi";
import { IoLocationOutline } from "react-icons/io5";
import { FaRegUserCircle } from "react-icons/fa";


const url = `${API_BASE_URL}/master/assets/uploads/`;
export default function MyInvitesCard({ invite }) {
    
    console.log("invite in card", invite);
    const totalGuests = (invite?.guests?.male || 0) + (invite?.guests?.female || 0);
    const pad2 = (n) => String(n ?? 0).padStart(2, "0");


    return (
        <div className="miv-card">
            {/* Media column */}
            <div className="event-miv-photo"><img src={url + invite?.events[0].image} alt="venue 2" /></div>
            <div className="miv-mediaColumn">
                <div className="miv-media">
                    <div className="miv-photos">
                        <div className="miv-photo-host-wrapper">
                            <div className="miv-photo-host-name"><FaRegUserCircle />
                            <p>{invite.guests.find(g => g.guest_type === "Host")?.guest_name}
                            </p>
                            </div>
                            <div className="miv-host">Host</div>
                        </div>
                        <div className="miv-photo"><img src={url + invite?.packageImage} alt="venue 1" />
                        </div>
                    </div>
                    <div className="miv-content">
                        <div className="miv-topRow">
                            <div className="miv-titleBlock">
                                <div className="miv-sub"><span className="miv-sub-logo"><img src={url + invite?.clubLogo} alt="" /></span> {invite?.clubName}</div>
                                <p className="miv-sub-address"><IoLocationOutline /> {invite?.address}</p>
                                <p className="miv-sub-food">{invite?.packageTitle}</p>

                                <div className="miv-chips">

                                    <span className="miv-chip"><IoRestaurantSharp /> Food-{invite?.foodserving}</span>
                                    <span className="miv-chip" ><BiDrink /> Drinks-{invite?.alcoholserving}</span>

                                </div>
                                <div className="miv-infoGrid">
                                    <div className="miv-infoItem">
                                        <div className="miv-infoLabel">
                                            <CalendarIcon /> Date
                                        </div>
                                        <div className="miv-infoPrimary">{invite?.party_date}</div>
                                    </div>

                                    <div className="miv-infoItem">
                                        <div className="miv-infoLabel">
                                            <ClockIcon /> Time
                                        </div>
                                        <div className="miv-infoPrimary">{invite?.party_time}- Onwards</div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* Info grid */}

            </div>

            {/* Main content */}


            {/* Guests summary */}
            <aside className="miv-guests">

                <div className="miv-actions">
                    {invite?.status && <span className="miv-status">{invite?.status}</span>}
                    <button
                        className="miv-ghostBtn"

                        type="button"
                    >
                        View Details
                    </button>
                </div>

                <div>
                    <div className="miv-guestsHead">
                        <div className="miv-guestsTitle">Current Guest Count</div>
                        <div className="miv-total">Total: {invite?.total_guests}</div>
                    </div>

                    <div className="miv-guestCards">
                        <div className="miv-guestCard miv-guestCard--male">
                            <div className="miv-guestNum">{pad2(invite?.male_qty)}</div>
                            <div className="miv-guestLabel">Male</div>
                        </div>
                        <div className="miv-guestCard miv-guestCard--female">
                            <div className="miv-guestNum">{pad2(invite?.female_qty)}</div>
                            <div className="miv-guestLabel">Female</div>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    );
}

/* --- tiny inline icon components (pure SVG) --- */
function CalendarIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="4" width="18" height="17" rx="4" />
            <path d="M8 2v4M16 2v4M3 10h18" />
        </svg>
    );
}
function ClockIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </svg>
    );
}
function PinIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    );
}
function PhoneIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 2h3l2 5-2 1a12 12 0 0 0 6 6l1-2 5 2v3a2 2 0 0 1-2 2 17 17 0 0 1-15-15 2 2 0 0 1 2-2z" />
        </svg>
    );
}
